module.exports = __webpack_public_path__ + "static/media/M006-noprivilege.fb681c56.svg";